import { Chip, CircularProgress, Typography, useTheme } from '@mui/material';
import {
  convertConstStringToText,
  SnackbarApiErrorMessage,
  useDataProvider,
  useSnackbar,
} from '@ui-framework/index';
import { useEffect, useState } from 'react';
import CustomIcons from './IconLibrary';

export const dispatchStatusConfig = theme => ({
  PENDING_ACCEPTANCE: {
    label: 'Pending Acceptance',
    borderColor: theme.palette.primary.dark,
    textColor: 'warning',
    Icon: CustomIcons.DISPATCH_STATUS_PENDING_ACCEPTANCE,
    iconColor: 'warning',
  },
  ASSIGNED: {
    label: 'Assigned',
    borderColor: theme.palette.primary.dark,
    textColor: 'success',
    Icon: CustomIcons.DISPATCH_STATUS_ASSIGNED,
    iconColor: 'success',
  },
  INTERVENTION_REQUIRED: {
    label: 'Intervention Required',
    borderColor: theme.palette.primary.dark,
    textColor: 'warning',
    Icon: CustomIcons.DISPATCH_STATUS_INTERVENTION_REQUIRED,
    iconColor: 'warning',
  },
  REVOKED: {
    label: 'Revoked',
    borderColor: theme.palette.primary.dark,
    textColor: 'error',
    Icon: CustomIcons.DISPATCH_STATUS_REVOKED,
    iconColor: 'error',
  },
  CANCELED: {
    label: 'Canceled',
    borderColor: theme.palette.primary.dark,
    textColor: 'error',
    Icon: CustomIcons.DISPATCH_STATUS_CANCELED,
    iconColor: 'error',
  },
});

function DispatchStatus({
  value,
  withIcon = false,
  showAsText = false,
  jobId,
}) {
  const theme = useTheme();
  const config = dispatchStatusConfig(theme);
  const [loading, setLoading] = useState(false);
  const [valueToShow, setValueToShow] = useState(value);
  const snackbar = useSnackbar();

  const provider =
    process.env.NODE_ENV === 'development' ? 'sxclServices' : 'default';
  const { getApiUrl, get } = useDataProvider(provider);

  async function getDispatchStatusByJob() {
    setLoading(true);

    const response = await get(
      `${getApiUrl()}/sxcl/v1/service-jobs/${jobId}/dispatches`,
    );

    if (response?.ok) {
      setValueToShow(response?.data?.data[0]?.status);
    } else {
      snackbar.showMessage({
        type: 'error',
        data: <SnackbarApiErrorMessage errors={response?.errors} />,
      });
    }

    setLoading(false);
  }

  useEffect(() => {
    if (jobId) {
      getDispatchStatusByJob();
    }
  }, [jobId]);

  if (loading) {
    return <CircularProgress sx={{ ml: 1 }} size={15} />;
  }

  if (config?.[valueToShow]) {
    const { label, textColor, Icon, iconColor } = config[valueToShow];

    return showAsText ? (
      <Typography sx={{ color: theme.palette[textColor]?.main }}>
        {label}
      </Typography>
    ) : (
      <Chip
        size="small"
        label={label}
        color={textColor}
        icon={
          withIcon && Icon ? (
            <Icon color={iconColor} fontSize="small" />
          ) : undefined
        }
      />
    );
  }

  return showAsText ? (
    <Typography color="inherit">
      {convertConstStringToText(valueToShow)}
    </Typography>
  ) : (
    <Chip size="small" label={convertConstStringToText(valueToShow)} />
  );
}

export default DispatchStatus;
